var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropdownInactiveArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.16 9.56a.445.445 0 00.292-.118l2.917-2.918a.458.458 0 000-.643.457.457 0 00-.642 0L7.102 8.508 4.477 5.881a.458.458 0 00-.642 0 .458.458 0 000 .643l2.917 2.918c.233.059.35.117.408.117z",
    fill: "#6C6B6B"
  })));
}
export default SvgDropdownInactiveArrow;